import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import { Sales_Crm_Web_Common_AttendanceFragmentDoc } from '@flowwai-frontend/bps-officer-web/graphql-docs'
import * as Apollo from '@apollo/client'
export type GetCurrentUserProfileQueryVariables = Types.Exact<{
   [key: string]: never
}>

export type GetCurrentUserProfileQuery = {
   __typename?: 'Query'
   getUserProfile: {
      __typename?: 'User'
      userId: string
      name?: string | null
      email?: string | null
      profilePicUrl?: string | null
      isAdmin: boolean
      permissions: Array<Types.UserPermission>
      googleAuthConsentStatus: Types.UserGoogleAuthConsentStatus
      signatureImgLink?: string | null
      attendance?: {
         __typename?: 'BaseUserAttendance'
         clockIn?: string | null
      } | null
      phoneNumber?: {
         __typename?: 'PhoneNumberResponse'
         dialCode: string
         iso2CountryCode?: string | null
         phoneNumber: string
      } | null
      identifications: Array<
         | {
              __typename?: 'RoleConfig'
              identificationId: string
              identificationType: Types.IdentificationType
           }
         | { __typename?: 'UserGroupConfig' }
      >
   }
}

export const GetCurrentUserProfileDocument = gql`
   query getCurrentUserProfile {
      getUserProfile {
         ... on User {
            userId
            name
            email
            profilePicUrl
            attendance {
               ...Sales_Crm_Web_Common_Attendance
            }
            isAdmin
            phoneNumber {
               dialCode
               iso2CountryCode
               phoneNumber
            }
            permissions
            googleAuthConsentStatus
            signatureImgLink
            identifications {
               ... on RoleConfig {
                  identificationId
                  identificationType
               }
            }
         }
      }
   }
   ${Sales_Crm_Web_Common_AttendanceFragmentDoc}
`
export type GetCurrentUserProfileQueryResult = Apollo.QueryResult<
   GetCurrentUserProfileQuery,
   GetCurrentUserProfileQueryVariables
>
